import { createSlice } from '@reduxjs/toolkit'
import { decryptText } from '../../utils/utils';
import { authUserReduxState, User } from '../reduxModels';

const auth = JSON.parse(decryptText(localStorage.getItem('user')) || '{}');

const defaultUser: User = {
	id: 0,
	name: "",
	sso_id: "",
	email: "",
	mobile_number: "",
	user_role: "",
	user_id:'',
	employee_code: "",
	vertical_code_id: 0,
	vertical_code: "",
	reporting_manager: "",
	branch_head: "",
	vertical_head_name: "",
	company_name: "",
	department_name: "",
	company_id: [],
	department_id: 0,
	first_name: "",
    last_name: "",
};

const initialState: authUserReduxState = {
	user: auth.user || {},
	token: auth.token || null,
	expires_at: auth.expires_at || null,
}

const authUserSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuthUser: (state, action) => {
			return { ...state, ...action.payload };
		},
		deleteAuthUser: () => {
			return { user: defaultUser, token: null, expires_at: null };  //{ user: {}, token: null, expires_at: null }
		}
	},
});

export const { setAuthUser, deleteAuthUser } = authUserSlice.actions;

export default authUserSlice.reducer